/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import { OnboardOffboardStatusDTO, TmTenantDTO } from "././index.d.ts";

export class Tenant<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description This API is for Tenant Manager
   *
   * @tags tenant-manager
   * @name OnboardTenant
   * @summary Onboard a tenant to the module
   * @request POST:/tenant/onboard
   * @secure
   */
  onboardTenant = (data: TmTenantDTO, params: RequestParams = {}) =>
    this.http.request<OnboardOffboardStatusDTO, any>({
      path: `/tenant/onboard`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This API is for Tenant Manager
   *
   * @tags tenant-manager
   * @name QueryOnboard
   * @summary Onboard a tenant to the module
   * @request POST:/tenant/onboard/query
   * @secure
   */
  queryOnboard = (data: TmTenantDTO, params: RequestParams = {}) =>
    this.http.request<OnboardOffboardStatusDTO, any>({
      path: `/tenant/onboard/query`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This API is for Tenant Manager
   *
   * @tags tenant-manager
   * @name OffboardTenant
   * @summary Offboard a tenant from the module
   * @request POST:/tenant/offboard
   * @secure
   */
  offboardTenant = (data: TmTenantDTO, params: RequestParams = {}) =>
    this.http.request<OnboardOffboardStatusDTO, any>({
      path: `/tenant/offboard`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This API is for Tenant Manager
   *
   * @tags tenant-manager
   * @name QueryOffboard
   * @summary Query offboard a tenant to the module
   * @request POST:/tenant/offboard/query
   * @secure
   */
  queryOffboard = (data: TmTenantDTO, params: RequestParams = {}) =>
    this.http.request<OnboardOffboardStatusDTO, any>({
      path: `/tenant/offboard/query`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
